import {
	Button,
	FormControlLabel,
	FormLabel,
	Switch,
	TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

export const ConfirmForm = ({ form }) => {
	const {
		control,
		watch,
		setValue,
		register,
		formState: { errors },
	} = form;

	const startDate = watch("startDate");
	const endDate = watch("endDate");

	const predefinedRanges = [
		{
			label: "Next 7 Days",
			range: [moment().add(1, "day"), moment().add(7, "days")],
		},
		{
			label: "Next 30 Days",
			range: [moment().add(1, "day"), moment().add(30, "days")],
		},
		{
			label: "Next Month",
			range: [
				moment().add(1, "month").startOf("month"),
				moment().add(1, "month").endOf("month"),
			],
		},
	];

	const handleRangeSelect = ([start, end]) => {
		setValue("startDate", start, { shouldValidate: true });
		setValue("endDate", end, { shouldValidate: true });
	};

	return (
		<Fragment>
			<Box my={3}>
				<FormLabel component="legend">
					Expected Delivery Range
				</FormLabel>
				<LocalizationProvider dateAdapter={AdapterMoment}>
					<Box my={3} sx={{ display: "flex", gap: 2 }}>
						<Controller
							name="startDate"
							control={control}
							rules={{ required: true }}
							render={({ field }) => (
								<DatePicker
									label="Start Date"
									maxDate={endDate}
									{...field}
									renderInput={(params) => (
										<TextField fullWidth {...params} />
									)}
								/>
							)}
						/>
						<Controller
							name="endDate"
							control={control}
							rules={{ required: true }}
							render={({ field }) => (
								<DatePicker
									label="End Date"
									minDate={startDate}
									{...field}
									renderInput={(params) => (
										<TextField fullWidth {...params} />
									)}
								/>
							)}
						/>
					</Box>
				</LocalizationProvider>
			</Box>
			<Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
				{predefinedRanges.map((preset) => (
					<Button
						key={preset.label}
						variant="outlined"
						size="small"
						onClick={() => handleRangeSelect(preset.range)}
					>
						{preset.label}
					</Button>
				))}
			</Box>
			<Box my={3}>
				<Controller
					name="return"
					control={control}
					defaultValue={false}
					render={({ field }) => (
						<FormControlLabel
							control={
								<Switch
									{...field}
									checked={field.value}
									// onChange={(e) =>
									// 	// field.onChange(product.out_of_stock)
									// }
									// disabled
									// sx={{ pointerEvents: "none" }}
								/>
							}
							label="Allow Return"
							labelPlacement="start"
						/>
					)}
				/>
			</Box>
			<Box my={3}>
				<TextField
					// InputLabelProps={{ shrink: true }}
					{...register("return", {})}
					fullWidth
					label="Return Policy"
					variant="outlined"
					multiline
					minRows={3}
					// value={brand.name}
					error={Boolean(errors.return)}
					helperText={errors.return?.message}
				/>
			</Box>
		</Fragment>
	);
};
